const ContactUs = () => {
  return (
    <section className="section3" style={{ backgroundColor: "#e8f4fd" }}>
      <h2>Contact Us</h2>
      <div className="cards3">
        <div className="card3" >
          <p><strong>Email:</strong> anuragraj8507@gmail.com</p><br/>
          <p><strong>Phone:</strong> +91 9955128105</p>
          <p><strong>Address:</strong> Maths Wallah HO, Muzaffarpur, Bihar, India</p>
          <p>We are here to assist you. Feel free to reach out to us for any queries or support.</p>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
